(function () {
  'use strict';

  if (window.__woodarqPdpV2HeaderContrastBooted) {
    if (window.WoodarqPdpV2HeaderContrast && typeof window.WoodarqPdpV2HeaderContrast.update === 'function') {
      window.WoodarqPdpV2HeaderContrast.update();
    }
    return;
  }

  window.__woodarqPdpV2HeaderContrastBooted = true;

  var HEADER_SELECTOR = '.main-header';
  var PDP_MARKER_SELECTOR = '[data-woodarq-pdp-v2-marker], [data-woodarq-pdp-v2-header-final-state]';
  var TAXI_VIEW_SELECTOR = '[data-taxi-view]';
  var DATA_ATTR = 'data-wd-pdp-v2-contrast';
  var BG_ATTR = 'data-wd-pdp-v2-bg';
  var SHELL_BG_VAR = '--wd-pdp-v2-header-shell-bg';
  var EXPLICIT_ATTR = 'data-wd-pdp-v2-header';
  var CONTRAST_LIGHT = 'light'; // light page background => brown/dark header content
  var CONTRAST_DARK = 'dark';   // dark page background => sand/light header content
  var nativeStateClasses = ['isSand', 'isNightshade', 'isPea', 'isGreen'];

  var lastContrast = '';
  var lastShellBg = '';
  var lastBgKey = '';
  var ticking = false;
  var observerPaused = false;

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function getComputedStyleSafe(el) {
    if (!el || el.nodeType !== 1 || !window.getComputedStyle) return null;
    return window.getComputedStyle(el);
  }

  function getActiveTaxiView() {
    var views = toArray(document.querySelectorAll(TAXI_VIEW_SELECTOR));
    if (!views.length) return null;

    var visibleViews = views.filter(function (view) {
      if (!view || !document.documentElement.contains(view)) return false;
      if (view.hidden || view.getAttribute('aria-hidden') === 'true') return false;

      var styles = getComputedStyleSafe(view);
      if (styles && (styles.display === 'none' || styles.visibility === 'hidden')) return false;

      return true;
    });

    // During Taxi transitions the old and incoming views can briefly coexist.
    // In this theme the last visible view is the current/incoming one.
    return visibleViews[visibleViews.length - 1] || views[views.length - 1] || null;
  }

  function getActiveScope() {
    if (window.WoodarqPdpV2Stability && typeof window.WoodarqPdpV2Stability.getActiveScope === 'function') {
      return window.WoodarqPdpV2Stability.getActiveScope() || document;
    }

    return getActiveTaxiView() || document;
  }

  function isPdpV2Active() {
    if (window.WoodarqPdpV2Stability && typeof window.WoodarqPdpV2Stability.isActive === 'function') {
      return window.WoodarqPdpV2Stability.isActive();
    }

    var activeView = getActiveTaxiView();
    if (activeView) return !!activeView.querySelector(PDP_MARKER_SELECTOR);
    return !!document.querySelector(PDP_MARKER_SELECTOR);
  }

  function parseColor(value) {
    if (!value || value === 'transparent') return null;

    var rgbMatch = String(value).match(/rgba?\(([^)]+)\)/i);
    if (rgbMatch) {
      var parts = rgbMatch[1].split(',').map(function (part) { return part.trim(); });
      if (parts.length < 3) return null;

      var r = Number(parts[0]);
      var g = Number(parts[1]);
      var b = Number(parts[2]);
      var a = parts.length > 3 ? Number(parts[3]) : 1;

      if (!isFinite(r) || !isFinite(g) || !isFinite(b) || !isFinite(a) || a <= 0.15) return null;
      return { r: r, g: g, b: b, a: a };
    }

    var hexMatch = String(value).match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);
    if (hexMatch) {
      var hex = hexMatch[1];
      if (hex.length === 3) {
        hex = hex.split('').map(function (char) { return char + char; }).join('');
      }

      return {
        r: parseInt(hex.slice(0, 2), 16),
        g: parseInt(hex.slice(2, 4), 16),
        b: parseInt(hex.slice(4, 6), 16),
        a: 1
      };
    }

    return null;
  }

  function luminance(color) {
    function channel(value) {
      value /= 255;
      return value <= 0.03928 ? value / 12.92 : Math.pow((value + 0.055) / 1.055, 2.4);
    }

    return 0.2126 * channel(color.r) + 0.7152 * channel(color.g) + 0.0722 * channel(color.b);
  }

  function colorToCss(color) {
    if (!color) return '';

    var r = Math.max(0, Math.min(255, Math.round(color.r)));
    var g = Math.max(0, Math.min(255, Math.round(color.g)));
    var b = Math.max(0, Math.min(255, Math.round(color.b)));

    return 'rgb(' + r + ', ' + g + ', ' + b + ')';
  }

  function shellColorFromContrast(contrast) {
    return contrast === CONTRAST_DARK ? '#212520' : '#d6d3bf';
  }

  function normalizeBgKey(key) {
    key = (key || '').toLowerCase();
    if (key === 'cream' || key === 'white' || key === 'light') return 'sand';
    if (key === 'black') return 'nightshade';
    return key;
  }

  function shellColorFromBgKey(key) {
    key = normalizeBgKey(key);
    if (key === 'sand') return '#d6d3bf';
    if (key === 'nightshade') return '#212520';
    if (key === 'green') return '#53503e';
    if (key === 'pea') return '#aaa47a';
    return '';
  }

  function nativeClassFromBgKey(key) {
    key = normalizeBgKey(key);
    if (!key) return '';

    return 'is' + key.charAt(0).toUpperCase() + key.slice(1);
  }

  function isLightBgKey(key) {
    key = (key || '').toLowerCase();
    return key === 'sand' || key === 'white' || key === 'cream' || key === 'light';
  }

  function isDarkBgKey(key) {
    key = (key || '').toLowerCase();
    return !!key && !isLightBgKey(key);
  }

  function contrastFromBgKey(key) {
    if (!key) return '';
    return isDarkBgKey(key) ? CONTRAST_DARK : CONTRAST_LIGHT;
  }

  function colorFromBgKey(key) {
    key = (key || '').toLowerCase();
    if (!key) return null;

    if (isLightBgKey(key)) return { r: 214, g: 211, b: 191, a: 1 };
    if (key === 'nightshade' || key === 'black') return { r: 33, g: 37, b: 32, a: 1 };
    if (key === 'green') return { r: 83, g: 80, b: 62, a: 1 };
    if (key === 'pea') return { r: 170, g: 164, b: 122, a: 1 };

    return { r: 21, g: 21, b: 21, a: 1 };
  }

  function explicitContrastValue(value) {
    value = (value || '').toLowerCase();
    if (value === CONTRAST_LIGHT || value === CONTRAST_DARK) return value;
    if (value === 'sand' || value === 'cream' || value === 'white') return CONTRAST_LIGHT;
    if (value === 'nightshade' || value === 'green' || value === 'black' || value === 'pea') return CONTRAST_DARK;
    return '';
  }

  function scopeContains(scope, el) {
    if (!scope || scope === document) return true;
    return scope === el || (scope.contains && scope.contains(el));
  }

  function isUsableElement(el, header, scope) {
    if (!el || el.nodeType !== 1) return false;
    if (header && (el === header || header.contains(el))) return false;
    if (!scopeContains(scope, el)) return false;

    var taxiView = el.closest && el.closest(TAXI_VIEW_SELECTOR);
    if (taxiView && scope !== document && taxiView !== scope) return false;

    var styles = getComputedStyleSafe(el);
    if (styles && (styles.display === 'none' || styles.visibility === 'hidden')) return false;

    return true;
  }

  function nearestExplicitContrast(el, scope) {
    var node = el;

    while (node && node.nodeType === 1 && scopeContains(scope, node)) {
      if (node.hasAttribute && node.hasAttribute(EXPLICIT_ATTR)) {
        var explicit = explicitContrastValue(node.getAttribute(EXPLICIT_ATTR));
        if (explicit) return explicit;
      }

      node = node.parentElement;
    }

    return '';
  }

  function nearestBackgroundForElement(el, scope) {
    var node = el;

    while (node && node.nodeType === 1 && scopeContains(scope, node)) {
      if (node.hasAttribute && node.hasAttribute('data-bg')) {
        var keyedColor = colorFromBgKey(node.getAttribute('data-bg'));
        if (keyedColor) return keyedColor;
      }

      var styles = getComputedStyleSafe(node);
      var bg = parseColor(styles && styles.backgroundColor);
      if (bg && bg.a > 0.15) return bg;

      node = node.parentElement;
    }

    return parseColor((getComputedStyleSafe(document.body) || {}).backgroundColor) ||
      parseColor((getComputedStyleSafe(document.documentElement) || {}).backgroundColor) ||
      { r: 214, g: 211, b: 191, a: 1 };
  }

  function getHeaderProbeY(header) {
    var rect = header.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight || 800;
    var headerBottom = rect.bottom || 0;

    // Match the main theme's header-color threshold while keeping it responsive
    // when the compact PDP v2 header is forced into its final state.
    return Math.max(1, Math.min(vh - 1, headerBottom + 1));
  }

  function findActiveSection(header, scope) {
    var probeY = getHeaderProbeY(header);
    var root = scope && scope.querySelectorAll ? scope : document;
    var best = null;
    var bestTop = -Infinity;

    toArray(root.querySelectorAll('[' + EXPLICIT_ATTR + '], [data-bg]')).forEach(function (section) {
      if (!isUsableElement(section, header, scope)) return;

      var rect = section.getBoundingClientRect();
      if (rect.top <= probeY && rect.bottom > probeY && rect.top >= bestTop) {
        best = section;
        bestTop = rect.top;
      }
    });

    return best;
  }

  function samplePageBackground(header, scope) {
    var rect = header.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight || 800;
    var y = Math.min(Math.max(rect.top + Math.min(rect.height * 0.55, 56), 4), vh - 4);
    var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    var sampleXs = [
      Math.round(width * 0.08),
      Math.round(width * 0.24),
      Math.round(width * 0.5),
      Math.round(width * 0.76),
      Math.round(width * 0.92)
    ];
    var samples = [];

    sampleXs.forEach(function (x) {
      var stack = typeof document.elementsFromPoint === 'function'
        ? document.elementsFromPoint(x, y)
        : [document.elementFromPoint(x, y)];

      for (var i = 0; i < stack.length; i += 1) {
        var el = stack[i];
        if (!isUsableElement(el, header, scope)) continue;

        var explicit = nearestExplicitContrast(el, scope);
        if (explicit) {
          samples.push(explicit);
        } else {
          samples.push(nearestBackgroundForElement(el, scope));
        }
        break;
      }
    });

    if (!samples.length) {
      var fallbackEl = document.elementFromPoint(width / 2, y) || document.body;
      samples.push(nearestBackgroundForElement(fallbackEl, scope));
    }

    return samples;
  }

  function chooseContrast(header) {
    lastShellBg = '';
    lastBgKey = '';

    var scope = getActiveScope();
    var activeSection = findActiveSection(header, scope);

    if (activeSection) {
      var explicit = nearestExplicitContrast(activeSection, scope);
      if (explicit) {
        lastShellBg = shellColorFromContrast(explicit);
        return explicit;
      }

      if (activeSection.hasAttribute && activeSection.hasAttribute('data-bg')) {
        var activeBgKey = normalizeBgKey(activeSection.getAttribute('data-bg'));
        var keyedContrast = contrastFromBgKey(activeBgKey);
        if (keyedContrast) {
          lastBgKey = activeBgKey;
          lastShellBg = shellColorFromBgKey(activeBgKey) || colorToCss(colorFromBgKey(activeBgKey)) || shellColorFromContrast(keyedContrast);
          return keyedContrast;
        }
      }
    }

    // Fallback: sample the real visible page background behind the header.
    // This keeps the header correct on browser back/forward even if the main
    // smooth-scroll header controller has stale bounds.
    var samples = samplePageBackground(header, scope);
    var darkVotes = 0;
    var lightVotes = 0;

    samples.forEach(function (sample) {
      if (typeof sample === 'string') {
        if (sample === CONTRAST_DARK) darkVotes += 1;
        if (sample === CONTRAST_LIGHT) lightVotes += 1;
        return;
      }

      if (luminance(sample) < 0.45) darkVotes += 1;
      else lightVotes += 1;
    });

    var chosenContrast = darkVotes > lightVotes ? CONTRAST_DARK : CONTRAST_LIGHT;

    for (var i = 0; i < samples.length; i += 1) {
      var sample = samples[i];

      if (typeof sample === 'string') {
        if (sample === chosenContrast) {
          lastShellBg = shellColorFromContrast(chosenContrast);
          break;
        }
        continue;
      }

      var sampleContrast = luminance(sample) < 0.45 ? CONTRAST_DARK : CONTRAST_LIGHT;
      if (sampleContrast === chosenContrast) {
        lastShellBg = colorToCss(sample);
        break;
      }
    }

    if (!lastShellBg) lastShellBg = shellColorFromContrast(chosenContrast);

    return chosenContrast;
  }

  function applyContrast(header, contrast) {
    if (!header || !contrast) return;

    var targetBgKey = normalizeBgKey(lastBgKey);
    var targetNativeClass = nativeClassFromBgKey(targetBgKey) ||
      (contrast === CONTRAST_DARK ? 'isNightshade' : 'isSand');
    var nativeClassIsCorrect = header.classList.contains(targetNativeClass);

    // Avoid repeatedly touching the header node. Chrome DevTools highlights
    // the element every time class/data attributes are mutated, even when the
    // visual state is already correct.
    var shellBg = lastShellBg || shellColorFromBgKey(targetBgKey) || shellColorFromContrast(contrast);
    var currentBgKey = header.getAttribute(BG_ATTR) || '';

    if (
      header.getAttribute(DATA_ATTR) === contrast &&
      currentBgKey === targetBgKey &&
      nativeClassIsCorrect &&
      header.style.getPropertyValue(SHELL_BG_VAR) === shellBg
    ) {
      lastContrast = contrast;
      return;
    }

    observerPaused = true;
    lastContrast = contrast;

    if (header.getAttribute(DATA_ATTR) !== contrast) {
      header.setAttribute(DATA_ATTR, contrast);
    }

    if (targetBgKey) {
      header.setAttribute(BG_ATTR, targetBgKey);
    } else {
      header.removeAttribute(BG_ATTR);
    }

    header.style.setProperty(SHELL_BG_VAR, shellBg);

    // Keep the original theme header classes in sync with the exact background
    // key that is currently behind the header. The text color already depends
    // on these native classes, and the shell now follows the same state.
    if (!nativeClassIsCorrect) {
      nativeStateClasses.forEach(function (className) {
        if (header.classList.contains(className)) header.classList.remove(className);
      });
      header.classList.add(targetNativeClass);
    }

    window.setTimeout(function () { observerPaused = false; }, 0);
  }

  function update() {
    ticking = false;

    var header = document.querySelector(HEADER_SELECTOR);
    if (!header) return;

    if (!isPdpV2Active()) {
      lastContrast = '';
      lastShellBg = '';
      lastBgKey = '';
      header.removeAttribute(DATA_ATTR);
      header.removeAttribute(BG_ATTR);
      header.style.removeProperty(SHELL_BG_VAR);
      return;
    }

    applyContrast(header, chooseContrast(header));
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  function start() {
    update();
    window.setTimeout(update, 80);
    window.setTimeout(update, 260);
    window.setTimeout(update, 620);
  }

  window.WoodarqPdpV2HeaderContrast = {
    update: update,
    refresh: requestUpdate
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.addEventListener('load', start, { passive: true });
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  window.addEventListener('orientationchange', start, { passive: true });
  window.addEventListener('pageshow', start);
  window.addEventListener('popstate', start);
  window.addEventListener('focus', start);

  [
    'taxi:render',
    'taxi:load',
    'taxi:after-render',
    'taxi:after-load',
    'pjax:complete',
    'turbo:load',
    'shopify:section:load',
    'shopify:section:select',
    'shopify:block:select',
    'woodarq:pdp-v2:reinit'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, start);
  });

  document.addEventListener('DOMContentLoaded', function () {
    var header = document.querySelector(HEADER_SELECTOR);
    if (!header || !window.MutationObserver) return;

    var observer = new MutationObserver(function () {
      if (!observerPaused) requestUpdate();
    });

    observer.observe(header, { attributes: true, attributeFilter: ['class', DATA_ATTR, BG_ATTR] });
  }, { once: true });
}());
